import React, { useContext, useEffect, Fragment } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'

export const GET_STATES_EVENT_CART_CHANGE = gql`
  query States($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-*",
      size: 0,
      aggs: {
        states: {
          terms: {
            field: "geoip.region_name.keyword",
            size: 50,
            order: {
              _key: "asc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export default function States (): JSX.Element {
  const { filters, setFilters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_STATES_EVENT_CART_CHANGE, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const { date } = filters
    getData({
      variables: { filters: { date } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <p>Refetching!</p>
  if (loading || !data) return <p>Loading!</p>
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations.states) return <p>No data found</p>

  const states: Array<string> = []
  data.eventCartChangeAggs.aggregations.states.buckets.map((state: any) => {
    states.push(state.key)
  })

  const onChange = (value: string[]) => {
    setFilters({
      geoipStates: value
    })
  }

  const typographLabel = 'Estado'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={states}
        defaultValues={filters.geoipStates}
        onChange={onChange}
      />
    </Fragment>
  )
}
